import { Button, Modal, Radio, Input, message } from 'antd';
import React, { useState } from 'react';
import { cancelOrder } from '../../../services/apiService';
import { useDispatch } from 'react-redux';
import { fetchIRDOrderList } from '../../../store/slices/ird/irdSlice';
import { getOrderSource } from '../../../services/apiService';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const CancelButtonComponent = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReason, setSelectedReason] = useState('');
    const [showCustomInput, setShowCustomInput] = useState(false);
    const [customReason, setCustomReason] = useState('');
    const { cancelReason, orderID } = props;
    const service = getOrderSource();

    const dispatch = useDispatch(); // Dispatch hook to trigger actions

    const handleCancelOrder = () => {
        setIsModalOpen(true);
    };

    const handleReasonChange = (e) => {
        const reason = e.target.value;
        setSelectedReason(reason);
        setShowCustomInput(reason === 'Other');
    };

    const handleCustomReasonChange = (e) => {
        setCustomReason(e.target.value);
    };

    const handleOk = async () => {
        const cancellationReasonId = cancelReason.find(
            (reason) => reason.content === selectedReason
        )?.id;

        // Validate inputs
        if (!cancellationReasonId && selectedReason !== 'Other') {
            message.error('Please select a valid reason for cancellation.');
            return;
        }

        if (selectedReason === 'Other' && !customReason.trim()) {
            message.error('Please provide a custom reason for cancellation.');
            return;
        }

        // Prepare data for x-www-form-urlencoded
        const params = new URLSearchParams();
        params.append('cancellation_reason_id', cancellationReasonId || ''); // Required for pre-defined reasons
        params.append(
            'other_reason',
            selectedReason === 'Other' ? customReason.trim() : selectedReason
        );

        try {
            const response = await cancelOrder(service, orderID, params);
            if (response.status === 202) {
                dispatch(fetchIRDOrderList());
                message.success('Order canceled successfully.');
            } else {
                message.error('Failed to cancel the order. Please try again.');
            }
        } catch (error) {
            console.log(error);
        }

        // Reset modal state
        setIsModalOpen(false);
        setSelectedReason('');
        setCustomReason('');
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedReason('');
        setCustomReason('');
        setShowCustomInput(false)
    };

    return (
        <>
            <Button onClick={handleCancelOrder} className='cancel-button'>Cancel Order</Button>
            <Modal
                title="Cancel Order"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit"
                cancelText="Close"
            >
                <p className="note">
                    <ExclamationCircleOutlined />
                    Note: The Action once performed cannot be reverted
                </p>
                    <Radio.Group
                        onChange={handleReasonChange}
                        value={selectedReason}
                        className='radio-btns'
                    >
                        {cancelReason?.map((reason) => (
                            <Radio key={reason.id} value={reason.content}>
                                {reason.content}
                            </Radio>
                        ))}
                    </Radio.Group>
                {showCustomInput && (
                    <Input.TextArea
                        rows={4}
                        value={customReason}
                        onChange={handleCustomReasonChange}
                        placeholder='Enter your custom reason here'
                        className='other-reason'
                    />
                )}
            </Modal>
        </>
    );
};

export default CancelButtonComponent;
